import { render, staticRenderFns } from "./Locked.vue?vue&type=template&id=6b106aa6&scoped=true"
import script from "./Locked.vue?vue&type=script&lang=js"
export * from "./Locked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b106aa6",
  null
  
)

export default component.exports